// src/pages/AppFooter.jsx
import React from "react";
import LegalQuickLinks from "../components/LegalQuickLinks";
import { LEGAL_VERSION } from "../legalVersion";

export default function AppFooter() {
  const year = new Date().getFullYear();

  return (
    <footer
      className="mt-10 border-t border-slate-200/70 bg-white/70 backdrop-blur
                 pt-6 pb-8 text-xs text-slate-600"
      style={{ paddingBottom: "calc(env(safe-area-inset-bottom,0px) + 2rem)" }}
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 flex flex-wrap items-center justify-between gap-3">
        <div>© {year} Campel</div>

        <nav aria-label="Información legal">
          <LegalQuickLinks
            as="menu"
            variant="comfy"                 // ancho del modal en el footer
            showVersion={true}
            linkClassName="underline underline-offset-2 hover:text-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-400/50 rounded-sm"
            className="text-slate-700"
          />
        </nav>
      </div>
    </footer>
  );
}
